<script setup lang="ts">
import store from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { DesktopPanelTheme, MobilePanelTheme } from ".";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const accountId = computed(() => route.params.id as string);

const menuDefault = computed(() => [
  {
    key: "accounts",
    icon: "change",
    label: t("common.labels.change_account"),
    url: "/accounts",
  },
  {
    key: "plans",
    icon: "plans",
    label: t("common.labels.plans"),
    url: "/plans",
  },
]);

const menuTechnical = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.home"),
    url: `/${accountId.value}/home`,
  },
  {
    key: "evaluate",
    icon: "evaluate",
    label: t("common.labels.evaluations"),
    url: `/${accountId.value}/evaluate`,
  },
  // {
  //   key: "report",
  //   icon: "reports",
  //   label: t("common.labels.reports"),
  //   url: `/${accountId.value}/report`,
  // },
]);

const menuAdmin = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.home"),
    url: `/${accountId.value}/home`,
  },
  {
    key: "cockpit",
    icon: "cockpit",
    label: t("common.labels.cockpit"),
    url: `/${accountId.value}/cockpit`,
  },
  {
    key: "evaluate",
    icon: "evaluate",
    label: t("common.labels.evaluations"),
    url: `/${accountId.value}/evaluate`,
  },
  {
    key: "register",
    icon: "add-form",
    label: t("common.labels.registrations"),
    url: `/${accountId.value}/register/company`,
  },
]);

const menuList = computed(() => {
  if (
    store.getters.type === "OWNER" ||
    store.getters.type === "ADMIN" ||
    store.getters.type === "MANAGER"
  )
    return menuAdmin.value;

  if (store.getters.type === "TECHNICAL" || store.getters.type === "ASSISTANT")
    return menuTechnical.value;

  return menuDefault.value;
});
</script>

<template>
  <template v-if="!$store.getters.mobile">
    <desktop-panel-theme :menu-list="menuList">
      <template #main>
        <slot></slot>
      </template>
    </desktop-panel-theme>
  </template>
  <template v-else>
    <mobile-panel-theme :menu-list="menuList" :account-id="accountId">
      <template #main>
        <slot></slot>
      </template>
    </mobile-panel-theme>
  </template>
</template>
